const childRoutes = [];

// Inyo National Forest - Wilderness Permits
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId',
    exact: true,
    componentName: 'PermitVenuePage',
    title: 'Inyo National Forest - Wilderness Permits'
};

// Detailed Availability
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/registration/detailed-availability',
    componentName: 'AvailabilityPage',
    title: 'Detailed Availability'
};

// Division Details
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/divisions/:divisionId',
    componentName: 'DivisionDetailsPage',
    title: 'Division Details'
};

// Which Permit Do I Need?
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/questionnaire',
    componentName: 'QuestionnairePage',
    title: 'Which Permit Do I Need?'
};

// Order Details
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/registration/:reservationIds',
    componentName: 'PermitRegistrationPage',
    title: 'Order Details',
    requireAuth: true,
};

// Order Confirmation
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/confirmation',
    componentName: 'CartlessConfirmationPage',
    title: 'Order Confirmation'
};

// Tertiary Content
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/additional-information',
    componentName: 'TertiaryContentPage',
    title: 'Additional Information'
};

export default childRoutes;
